/* ==========================================================================
   Mega Menu — component-mega-menu.js
   Upload to: assets/component-mega-menu.js
   ========================================================================== */

(function () {
  var nav = document.querySelector('[data-mega-nav]');
  if (!nav) return;

  var mobileToggle = nav.querySelector('[data-mega-toggle]');
  var items = nav.querySelectorAll('.mega-nav__item.has-dropdown');
  var isMobile = function () { return window.innerWidth < 990; };

  /* -------------------- Mobile hamburger -------------------- */
  if (mobileToggle) {
    mobileToggle.addEventListener('click', function () {
      var open = nav.hasAttribute('data-mobile-open');
      if (open) {
        nav.removeAttribute('data-mobile-open');
        mobileToggle.setAttribute('aria-expanded', 'false');
      } else {
        nav.setAttribute('data-mobile-open', '');
        mobileToggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* -------------------- Top level items -------------------- */
  items.forEach(function (item) {
    var link = item.querySelector(':scope > .mega-nav__link');

    link.addEventListener('click', function (e) {
      if (isMobile()) {
        e.preventDefault();
        var wasOpen = item.classList.contains('is-open');
        // close any open sibling accordions
        items.forEach(function (sib) {
          sib.classList.remove('is-open');
          var sibLink = sib.querySelector(':scope > .mega-nav__link');
          if (sibLink) sibLink.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          link.setAttribute('aria-expanded', 'true');
        }
      }
    });

    /* -------------------- Level 2 -> Level 3 panel switching -------------------- */
    var triggers = item.querySelectorAll('[data-mega-sub-trigger]');
    triggers.forEach(function (trigger) {
      var showPanel = function () {
        var targetId = trigger.getAttribute('data-target');

        item.querySelectorAll('.mega-nav__level-2-item').forEach(function (el) {
          el.classList.remove('is-active');
        });
        item.querySelectorAll('.mega-nav__level-3').forEach(function (panel) {
          panel.classList.remove('is-active');
        });

        trigger.classList.add('is-active');
        var target = item.querySelector('#' + CSS.escape(targetId));
        if (target) target.classList.add('is-active');
      };

      trigger.addEventListener('mouseenter', function () {
        if (!isMobile()) showPanel();
      });

      trigger.addEventListener('click', function (e) {
        if (isMobile()) {
          e.preventDefault();
          var wasActive = trigger.classList.contains('is-active');
          showPanel();
          // on mobile, tapping again collapses the panel back
          var targetId = trigger.getAttribute('data-target');
          var target = item.querySelector('#' + CSS.escape(targetId));
          if (wasActive && target) {
            target.classList.toggle('is-active');
            trigger.classList.toggle('is-active');
          }
        }
      });
    });
  });

  /* -------------------- Close menus on outside click (desktop) -------------------- */
  document.addEventListener('click', function (e) {
    if (!nav.contains(e.target)) {
      nav.removeAttribute('data-mobile-open');
      items.forEach(function (item) { item.classList.remove('is-open'); });
    }
  });

  /* -------------------- Close mobile menu on resize to desktop -------------------- */
  window.addEventListener('resize', function () {
    if (!isMobile()) {
      nav.removeAttribute('data-mobile-open');
      items.forEach(function (item) { item.classList.remove('is-open'); });
    }
  });

  /* -------------------- Keyboard accessibility (Escape closes) -------------------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      nav.removeAttribute('data-mobile-open');
      items.forEach(function (item) { item.classList.remove('is-open'); });
    }
  });
})();
